// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TestCards: MarkdocTagRegistration = {
  tag: 'test-cards',
  component: 'TestCards',
  selfClosing: true,
  attributes: {
    type: {
      type: String,
      default: 'default',
      matches: ['default', 'terminal'],
    },
  },
};
